import React from 'react';
import { Avatar } from 'antd';

const FormItemUserDetail = ({ value }) => {
  if (!value) {
    return null;
  }

  return (
    <div className="gx-d-flex gx-align-items-center">
      <Avatar
        src={`${process.env.REACT_APP_API_URL}/users/${value?.id}/image`}
      />
      <div className="gx-ml-1">
        <div className="">{value?.name}</div>
        <div className="gx-fs-11 gx-text-grey">{value?.email}</div>
      </div>
    </div>
  );
};

export default FormItemUserDetail;
